<template>
	<div id="app">
		<c-header></c-header>
		<router-view></router-view>
		<c-ad-foot></c-ad-foot>
		<c-footer></c-footer>
	</div>
</template>

<script>

import cHeader from "./component/header.vue";
import cFooter from "./component/footer.vue";
import cAdFoot from "./component/ad-foot.vue";

export default {
	components: {
		cHeader,
		cFooter,
		cAdFoot
	},
	data (){
		return {
		}
	}
}

</script>


// WEBPACK FOOTER //
// App.vue?389cebac